import { X } from "lucide-react";

import { TranslatedText } from "@/components/common/text";

export const ChatAssistantHeader = ({ onClose }) => {
    return (
        <div className="flex items-center justify-between gap-2.5 pl-5 py-2 bg-cm-p-accent-50 border-b border-cm-p-outline">
            <span className="text-cm-p-text-primary text-base font-medium">
                <TranslatedText>CM Assistant</TranslatedText>
            </span>
            <button
                type="button"
                className="flex items-center justify-center h-10 px-4 rounded-md text-cm-p-text-primary"
                onClick={onClose}
                aria-label="Close assistant"
            >
                <X size={16} />
            </button>
        </div>
    );
};
